var OrbitHelper = function(){

	function getEnterBezierData($curve) {
		var width = $curve.width(),
				height = $curve.height();
		return [
			{x: 0, y: 0 },
			{x: width * 0.125, y: height * -0.4375 },
			{x: width * 0.25, y: height * -0.75 },
			{x: width * 0.375, y: height * -0.9375 },
			{x: width * 0.5, y: height * -1 },
		];
	}

	function getExitBezierData($curve) {
		var width = $curve.width(),
				height = $curve.height();
		return [
			{x: 0, y: 0},
			{x: width * 0.125, y: height * 0.0625 },
			{x: width * 0.25, y: height * 0.25 },
			{x: width * 0.375, y: height * 0.5416666667 },
			{x: width * 0.5, y: height * 1 },
		];
	}

	return {
		getEnterBezierData: getEnterBezierData,
		getExitBezierData: getExitBezierData
	};
};

export default OrbitHelper();